var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNarrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23447 6.16559C4.0845 6.01557 4.00024 5.81212 4.00024 5.59999C4.00024 5.38786 4.0845 5.18441 4.23447 5.03439L7.43447 1.83439C7.5845 1.68441 7.78794 1.60016 8.00007 1.60016C8.2122 1.60016 8.41565 1.68441 8.56567 1.83439L11.7657 5.03439C11.9114 5.18527 11.992 5.38735 11.9902 5.59711C11.9884 5.80687 11.9043 6.00752 11.7559 6.15584C11.6076 6.30417 11.407 6.3883 11.1972 6.39013C10.9874 6.39195 10.7854 6.31131 10.6345 6.16559L8.80007 4.33119V13.6C8.80007 13.8122 8.71579 14.0156 8.56576 14.1657C8.41573 14.3157 8.21225 14.4 8.00007 14.4C7.7879 14.4 7.58442 14.3157 7.43439 14.1657C7.28436 14.0156 7.20007 13.8122 7.20007 13.6V4.33119L5.36567 6.16559C5.21565 6.31556 5.0122 6.39982 4.80007 6.39982C4.58794 6.39982 4.3845 6.31556 4.23447 6.16559Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowUp);
export default __webpack_public_path__ + "static/media/ArrowNarrowUp.82a0a26e03ea99af1a84b46229827f92.svg";
export { ForwardRef as ReactComponent };